import React, { FC } from 'react';
import getClassName from 'src/common/utils/getClassName';
import s from './CaptainTemplate.module.scss';
import { ListingCaptainOption } from '../../utils/getListingCaptainOption';
import { CAPTAIN_OPTION_KEYS } from '../../constants';
import Icon, { IconIds } from '../IconDS22';

const captainOptionMap: Record<string, IconIds> = {
  [CAPTAIN_OPTION_KEYS.PROVIDED]: 'captain-provided',
  [CAPTAIN_OPTION_KEYS.ARRANGED_SEPARATELY]: 'captain-arranged',
  [CAPTAIN_OPTION_KEYS.NOT_PROVIDED]: 'captain-unavailable',
};

type Props = {
  classNameModifier?: string;
  selectedOption?: Pick<ListingCaptainOption, 'key'>;
};

const CaptainTemplate: FC<Props> = ({ children, classNameModifier, selectedOption }) => {
  const showIcon = selectedOption && selectedOption.key && captainOptionMap[selectedOption.key];
  return (
    <div className={s.root}>
      {showIcon && (
        <Icon
          id={captainOptionMap[selectedOption?.key]}
          size="xl"
          className={getClassName(s, 'icon', classNameModifier)}
        />
      )}
      <div className={getClassName(s, 'content', classNameModifier)}>{children}</div>
    </div>
  );
};

export default CaptainTemplate;
